import { Fragment } from "react";

import { useSelector } from "../../../../../../redux/hooks";
import { deepClone } from "../../../../../../utils";
import { StyledMedicalSection } from "../MedicalHistory.styled";
import MedicalDynamic from "./DynamicSection/MedicalDynamic";
import MedicalLeaveHistory from "./MedicalLeaveHistory/MedicalLeaveHistory";
import { MedicalPatientInformation } from "./MedicalPatientInformation/MedicalPatientInformation";
import MedicalStandalone from "./StandaloneSection/MedicalStandalone";
interface Props {
  refetch: () => Promise<void>;
}
const MedicalSections = ({ refetch }: Props) => {
  const { others } = useSelector(state => state.medicalHistory);
  return (
    <StyledMedicalSection>
      <MedicalPatientInformation refetch={refetch} />
      <MedicalLeaveHistory />
      {deepClone(others).map((section: any) =>
        section.standalone ? (
          <MedicalStandalone key={section.name} {...section} />
        ) : (
          <MedicalDynamic key={section.name} {...section} />
        ),
      )}
    </StyledMedicalSection>
  );
};
export default MedicalSections;
